// "Link kopiëren" in the share row (templates/parts/share.php).
// Copies data-copy-url and shows data-copied-label for 2 s. When the
// Clipboard API is missing or refused, the label stays as it is.
const copyLink = () => {
	document.querySelectorAll('[data-copy-url]').forEach((button) => {
		const label = button.querySelector('.nm-share__copy-text') || button;
		const original = label.textContent;
		let timer;

		button.addEventListener('click', async () => {
			try {
				await navigator.clipboard.writeText(button.dataset.copyUrl);
			} catch {
				return;
			}
			label.textContent = button.dataset.copiedLabel || 'Gekopieerd';
			clearTimeout(timer);
			timer = setTimeout(() => {
				label.textContent = original;
			}, 2000);
		});
	});
};

export default copyLink;
